import Vue from 'vue'
import ImagesLoaded from 'imagesloaded'
import jQueryBridget from 'jquery-bridget'
import Isotope from 'isotope-layout'
import skillFilters from '../views/skills-filter.vue'

jQueryBridget('isotope', Isotope, $)
jQueryBridget('imagesLoaded', ImagesLoaded, $)

export default {
    init() {
        new Vue({
            el: '#filter-grid',
            components: {
                'skill-filter': skillFilters,
            },
            data: {
                selectedTitle: 'Select a Location to View Skills',
                selectedSlug: 'none',
                selectedCamp: '',
                processing: false,
            },

            /* :: Mounted
            {+} ---------------------------------- */
            mounted() {
                // :: Start Isotope ------------ //
                const skills = this.$refs.skills
                $(skills).imagesLoaded(() => {
                    $(skills).isotope({
                        itemSelector: '[data-skill-card]',
                        layoutMode: 'fitRows',
                        resizable: false,
                        filter: '.none'
                    })
                })

                // :: URL Hash Processing ------------ //
                if (this.$el.attributes['data-dynamic-name'].value && this.$el.attributes['data-dynamic-slug'].value) {
                    this.selectedTitle = this.$el.attributes['data-dynamic-name'].value
                    this.selectedSlug = this.$el.attributes['data-dynamic-slug'].value

                    $(skills).isotope({ filter: `[data-filter-${this.selectedSlug}]` })
                }
            },

            // π ----
            // :: METHODS ---------------------------::
            // ____
            methods: {
                /* :: Open Door
                {+} ---------------------------------- */
                openDoor() {
                    const openDropDown = new TimelineMax()

                    $(this.$refs.dropDown).removeClass('opacity-0 invisible')

                    openDropDown
                        .to(this.$refs.dropDownBG, 0.48, {
                            height: '100%',
                            ease: Circ.easeInOut,
                        })
                        .to(this.$refs.dropDownContent, 0.48, {
                            opacity: 1,
                            onComplete: () => {
                                document.addEventListener('click', this.closeDoor)
                            },
                        })
                },

                /* :: Close Door
                {+} ---------------------------------- */
                closeDoor() {
                    document.removeEventListener('click', this.closeDoor)

                    const closeDropDown = new TimelineMax()
                    this.processing = true

                    closeDropDown
                        .to(this.$refs.dropDownContent, 0.32, {
                            opacity: 0,
                        })
                        .to(this.$refs.dropDownBG, 0.32, {
                            height: '0%',
                            delay: -0.16,
                            ease: Circ.easeInOut,
                            onComplete: () => {
                                $(this.$refs.dropDown).addClass('opacity-0 invisible')

                                setTimeout(() => {
                                    this.processing = false
                                }, 1000)
                            },
                        })
                },
                selectCamp() {
                    const skills = this.$refs.skills;
                    
                    if (this.selectedSlug !== 'none') {
                        $(skills).isotope({ filter: `[data-filter-${this.selectedSlug}]` });
                    } else {
                        $(skills).isotope({ filter: '.none' });
                    }
                }
            },
        })
    },
    finalize() {},
}
